import z from 'zod';

export interface DecodedInvitationToken {
  Email: string;
  FirstName: string;
  Id: number;
  UserName: string;
  exp: number;
}

export const tokenSchema = z.object({
  Email: z.string().email(),
  FirstName: z.string(),
  Id: z.number(),
  UserName: z.string(),
  exp: z.number(),
});
